import { render, staticRenderFns } from "./modalGuardado.vue?vue&type=template&id=59fda47d&scoped=true&"
import script from "./modalGuardado.vue?vue&type=script&lang=js&"
export * from "./modalGuardado.vue?vue&type=script&lang=js&"
import style0 from "./modalGuardado.vue?vue&type=style&index=0&id=59fda47d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fda47d",
  null
  
)

export default component.exports